import { useMemo } from 'react'
import { useRecoilState } from 'recoil'

import { BiometricsAppPermission, biometricPermissionAtom } from '../state/biometrics.atom'

/**
 * Hook to manage the biometrics permission state
 * @returns biometricPermission - The current biometrics permission state (granted, denied, or prompt)
 */
export const useBiometricsPermission = () => {
  const [biometricPermission, setBiometricPermission] = useRecoilState(biometricPermissionAtom)

  const biometricPermissionGranted = useMemo(() => {
    return biometricPermission === BiometricsAppPermission.GRANTED
  }, [biometricPermission])

  /**
   * Update the biometrics permission in the storage and atom state
   * @param permission - The new permission state (granted, denied, or prompt)
   */
  const updateBiometricsPermission = (permission: BiometricsAppPermission) => {
    setBiometricPermission(permission)
  }

  return {
    biometricPermissionGranted,
    biometricPermission,
    updateBiometricsPermission,
  }
}
